"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _webgltextureLoader = require("webgltexture-loader");

var _drawNDArrayTexture = _interopRequireDefault(require("./drawNDArrayTexture"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NDArrayTextureLoader = /*#__PURE__*/function (_webgltextureLoader$W) {
  _inherits(NDArrayTextureLoader, _webgltextureLoader$W);

  var _super = _createSuper(NDArrayTextureLoader);

  function NDArrayTextureLoader(gl) {
    var _this;

    _classCallCheck(this, NDArrayTextureLoader);

    _this = _super.call(this, gl);

    _defineProperty(_assertThisInitialized(_this), "floatSupported", void 0);

    _this.floatSupported = gl.getExtension("OES_texture_float") && gl.getExtension("OES_texture_float_linear");
    return _this;
  }

  _createClass(NDArrayTextureLoader, [{
    key: "canLoad",
    value: function canLoad(obj) {
      return obj.shape && obj.data && obj.stride;
    }
  }, {
    key: "inputHash",
    value: function inputHash(input) {
      return input;
    }
  }, {
    key: "getNoCache",
    value: function getNoCache(input) {
      var gl = this.gl;
      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);

      var _input$shape = _slicedToArray(input.shape, 2),
          width = _input$shape[0],
          height = _input$shape[1];

      (0, _drawNDArrayTexture.default)(gl, texture, input, this.floatSupported);
      return {
        texture: texture,
        width: width,
        height: height
      };
    }
  }, {
    key: "update",
    value: function update(input) {
      // For now we assume the NDArray always change & need a redraw but we might try to only update if changes later
      var gl = this.gl;

      var _this$get = this.get(input),
          texture = _this$get.texture;

      gl.bindTexture(gl.TEXTURE_2D, texture);
      (0, _drawNDArrayTexture.default)(gl, texture, input, this.floatSupported);
    }
  }]);

  return NDArrayTextureLoader;
}(_webgltextureLoader.WebGLTextureLoaderSyncHashCache);

_webgltextureLoader.globalRegistry.add(NDArrayTextureLoader);

var _default = NDArrayTextureLoader;
exports.default = _default;